// authService.js
import { Auth } from 'aws-amplify';

export async function getAuthToken() {
  try {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  } catch (error) {
    console.error("Error fetching access token", error);
    return null;
  }
}